<template>
    <div class="search-wrap" :class="{'dropdown':!dropdown}" :style="{height: H}" id="search_top_con">
        <Form ref="tempform" :model="tempform" label-width="80px" size="mini" v-show="dropdown">
            <Row :gutter="15">
                <Col :span="6">
                <FormItem label="ISBN：" prop="isbns" class="labelwrap">
                    <Input placeholder="可输入多个ISBN" @click.native="multiplePop('ISBN','isbns')" readonly v-model="tempform.isbns"></Input>
                    <i v-if="tempform.isbns" class="el-icon-circle-close circleclose" @click="clearValue('isbns')"></i>
                </FormItem>
                </Col>
                <Col :span="6">
                <FormItem label="书名：" prop="bookname">
                    <Input placeholder="请输入书名" v-model="tempform.bookname" clearable></Input>
                </FormItem>
                </Col>
                <Col :span="6">
                <FormItem label="作者：" prop="author">
                    <Input placeholder="请输入作者" v-model="tempform.author" clearable></Input>
                </FormItem>
                </Col>
                <Col :span="6">
                <FormItem label="出版社：" prop="pubname" class="labelwrap" v-if="pubShow">
                    <Input placeholder="请输入搜索条件" readonly v-model="tempform.pubname" @click.native="pubpop(tempform.pubname)"></Input>
                    <i v-if="tempform.pubname" class="el-icon-circle-close circleclose" @click="clearValue('pubname','','pubid')"></i>
                </FormItem>
                </Col>
                <Col :span="6">
                    <FormItem label="专题分类：" prop="activitytag" v-if="zttagShow">
                        <Select v-model="tempform.activitytag"  multiple collapse-tags placeholder="请选择" class="sel_collection">
                            <Option v-for="item in tagArr" :key="item.key" :label="item.value" :value="item.key"></Option>
                        </Select> 
                    </FormItem>
                </Col>
                <Col :span="6">
                    <FormItem label="中图法：" prop="ztf" class="labelwrap" v-if="ztfShow">
                        <Input placeholder="选择中图分类" v-model="tempform.ztf" :title="tempform.ztf" readonly @click.native="ztfflWindow"></Input>
                        <i v-if="tempform.ztf" class="el-icon-circle-close circleclose" @click="clearValue('ztf','classifydata')"></i>
                    </FormItem>
                </Col>
                <Col :span="6">                
                    <FormItem label="学科分类:" prop="subjectShow" class="labelwrap" v-if="xkShow">
                        <Input placeholder="选择学科分类" readonly v-model="tempform.subjectShow" :title="tempform.subjectShow" @click.native="styClass" ></Input>
                        <i v-if="tempform.subjectShow" class="el-icon-circle-close circleclose" @click="clearValue('subjectShow','xuekedata','xkfl')"></i>
                    </FormItem>
                    <!-- <FormItem label="学科分类：" prop="subjectShow" class="labelwrap">
                        <Input placeholder="选择学科分类" readonly v-model="tempform.subjectShow" :title="tempform.subjectShow" @click.native="styClass" ></Input>
                        <i v-if="tempform.subjectShow" class="el-icon-circle-close circleclose" @click="clearValue('subjectShow','xuekedata','xkfl')"></i>
                    </FormItem> -->
                </Col>
                <Col :span="6">
                    <FormItem label="大众分类：" prop="dazhongshow" class="labelwrap" v-if="dzShow">
                        <Input placeholder="选择大众分类" readonly v-model="tempform.dazhongshow" :title="tempform.dazhongshow" @click.native="pubClass"></Input>
                        <i v-if="tempform.dazhongshow" class="el-icon-circle-close circleclose" @click="clearValue('dazhongshow','dazhongdata','popularCode')"></i>
                    </FormItem>
                </Col>
                <div v-show="showAdditionalSearch">
                <Col :span="6">
                    <FormItem label="码洋：" >
                        <div class="s-input">
                            <FormItem prop="myfrom" class="no-margin" >
                                <Input type="text" v-model="tempform.myfrom" clearable class="midbox"></Input>
                                <i class="font">元</i>
                            </FormItem>
                        </div> 
                        <Col class="line" :span="2">-</Col>
                        <div class="s-input">
                            <FormItem prop="myto" class="no-margin">
                                <Input type="text" v-model="tempform.myto" clearable  class="midbox" ></Input>
                                <i class="font">元</i>
                            </FormItem>
                        </div>
                    </FormItem>
                </Col>
                <Col :span="6">
                    <FormItem label="尺寸：">
                        <div class="s-input">
                            <FormItem prop="sizefrom" class="no-margin">
                                <Input type="text" v-model="tempform.sizefrom" clearable class="midbox"></Input>
                                <i class="font">cm</i>
                            </FormItem>
                        </div>
                        <Col class="line" :span="2">-</Col>
                        <div class="s-input">
                            <FormItem prop="sizeto" class="no-margin">
                                <Input type="text" v-model="tempform.sizeto" clearable class="midbox"></Input>
                                <i class="font">cm</i>
                            </FormItem>
                        </div>
                    </FormItem>
                </Col>
                <!-- 6.10 适用对象改模糊检索 -->
                <!-- <FormItem label="适用对象:" prop="sydxChecked">
                    <CheckboxGroup v-model="sydxChecked">
                        <Checkbox v-for="item in applyArr" :key="item.key" :label="item.key" >{{item.value}}</Checkbox>
                    </CheckboxGroup>
                </FormItem> -->
                <Col :span="6">
                    <FormItem label="适用对象：" prop="useobj">
                        <!-- <Input placeholder="请输入适用对象" v-model="tempform.useobj" clearable></Input> -->
                        <Select v-model="tempform.useobj"  placeholder="请选择" class="sel_collection">
                            <Option v-for="item in objArr" :key="item.key" :label="item.value" :value="item.key"></Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col :span="6">
                    <FormItem label="装帧：" prop="zhuangj">
                        <Select v-model="tempform.zhuangj" placeholder="请选择" class="sel_collection">
                            <Option v-for="item in bindArr" :key="item.key" :label="item.value" :value="item.key"></Option>
                        </Select>
                    </FormItem>
                </Col>
               
                <Col :span="6">
                    <FormItem label="出版时间：">
                        <div class="date-input">
                            <FormItem prop="pubfrom" class="no-margin">
                                <DatePicker type="month" placeholder="选择日期" value-format="yyyy-MM-dd" style="width: 100%;" :picker-options="startTime" v-model="tempform.pubfrom"></DatePicker>
                            </FormItem>
                        </div>
                        <Col class="line" :span="2">-</Col>
                        <div class="date-input">
                            <FormItem prop="pubto" class="no-margin">
                                <DatePicker type="month" placeholder="选择日期" value-format="yyyy-MM-dd" style="width: 100%;" :picker-options="endTime" v-model="tempform.pubto"></DatePicker>
                            </FormItem>
                        </div>
                    </FormItem>
                </Col>
                <Col :span="6">
                    <FormItem label="交付方式：" prop="delivery">
                        <Select v-model="tempform.delivery" placeholder="请选择" class="sel_collection">
                            <Option value="" label="全部"></Option>
                            <Option value="0" label="期货"></Option>
                            <Option value="1" label="现货"></Option>
                        </Select>
                    </FormItem>
                </Col>
                <!-- <Col :span="6"  v-if="iSlogin()">
                    <FormItem label="是否已订购：" prop="isaddcar">
                        <Select v-model="tempform.isaddcar" placeholder="请选择" class="sel_collection">
                            <Option value="0" label="全部"></Option>
                            <Option value="1" label="已订购"></Option>
                            <Option value="2" label="未订购"></Option>
                        </Select>
                    </FormItem>
                </Col> -->
                <Col :span="6"  v-if="iSlogin()">
                    <FormItem label="阅读类型：">
                        <Select v-model="goodsType" placeholder="请选择" class="sel_collection">
                            <Option :value="1" label="纸质书"></Option>
                            <!-- <Option :value="2" label="电子书"></Option> -->
                            <Option :value="2" label="纸电同步"></Option>
                            <Option :value="4" label="期刊"></Option>
                        </Select>
                    </FormItem>
                </Col>
            </div>
            <div style=" width: 90%;  display: flex; justify-content: end; ">
                <el-button plain  @click="toggleAdditionalSearch" size="mini" class="toggle-btn">
                    {{ showAdditionalSearch ? '收起' : '更多检索条件' }}
                  </el-button>
            </div>
            
            </Row>  
        </Form>    
        <div class="search-btn"  v-show="dropdown">
            <Button type="primary" size="mini" @click="onSubmit" class="submit-btn">检索</Button>
            <Button @click.native="resetForm" size="mini" class="iconfont icon-reset reset-btn">重置</Button>
        </div>

        <span class="drop_btn" @click="toggleSlide(500)" :class="{'el-icon-top':dropdown,'el-icon-bottom':!dropdown}"   >{{dropdown? '收起':'展开'}}检索条件</span>

    </div>
</template>

<script>
    import { Row, Col, Form, FormItem, Input, Button,Notification, Checkbox, DatePicker ,CheckboxGroup,Select,Option} from 'element-ui'
    import classifyPop from './ClassifyPop'
    import studyclass from './studyClassPop'
    import publicpop from './publicPop'
    import popup from '../common/plugin/dialog/index.js'
    import pubDialog from './pubDialog'
    import keyValuePop from './textareaDialog'
    import Cookies from 'js-cookie'
  import { insertPoint } from '@/api/insertPoints'   //添加埋点

    export default {
        props: [ 'isShowType' ],
        data() {
            let vm = this;/*  */
            return {
                goodsType: 1,
                
                pubShow: true,
                zttagShow: true,
                ztfShow: true,
                xkShow: true,
                dzShow: true,
                dropdown:true,//是否展开
                H:`280px`,
                showAdditionalSearch:false,
                // 适用对象
                objArr:[  
                    {key:'',value:'全部'},
                    {key:'本科及以上',value:'本科及以上'},
                    {key:'高职',value:'高职'},
                    {key:'少儿',value:'少儿'},
                    {key:'音像电子',value:'音像电子'},
                    {key:'中职',value:'中职'},
                    {key:'职业教育',value:'职业教育'},
                    {key:'成人教育',value:'成人教育'},
                    {key:'幼儿',value:'幼儿'},
                    {key:'小学',value:'小学'},
                    {key:'初中',value:'初中'},
                    {key:'中小学',value:'中小学'},
                    {key:'高中',value:'高中'},
                    {key:'青少年',value:'青少年'},
                    {key:'通俗读物',value:'通俗读物'},
                    {key:'继续教育',value:'继续教育'}
                ],
                zzArr:[//装帧
                    {key:'',value:'平装'},
                    {key:'精装',value:'精装'},
                    {key:'线装',value:'线装'},
                    {key:'活页',value:'活页'},
                    {key:'其它',value:'其它'},
                    {key:'函装',value:'函装'},
                    {key:'盒装',value:'盒装'}
                ],
                dzlxArr:[//读者类型
                    {key:'100045.101',value:'高职高专'},
                    {key:'100045.102',value:'中专'},
                    {key:'100045.103',value:'本科及以上'},
                    {key:'100045.104',value:'少儿'},
                    {key:'100045.105',value:'其他'}
                ],
                tagArr:[
                    {key:'10128',value:'吾有所爱，其名华夏'},
                    {key:'10129',value:'你好，生活'},
                    {key:'10130',value:'遇见艺术，魅力绽放'},
                    {key:'10131',value:'细览典籍，与先贤畅谈'},
                    {key:'10132',value:'热点，搜一搜'},
                    {key:'10133',value:'坚定创新自信，瞄准科技前沿'},
                    {key:'10134',value:'新书抢先看'},
                    {key:'10135',value:'生活一地鸡毛 但也要不断前进'},
                    {key:'10136',value:'向上吧，少年'},
                    // {key:'10137',value:'漫游儿童大咖'},
                ],
                tempform: {//表单信息
                    // goodstype:1,
                    isbns: null,
                    bookname: null,
                    author: null,
                    pubname: null,
                    pubid:null,
                    pubfrom: null,
                    pubto:null,
                    ztf: null,
                    subjectShow: null,
                    xkfl:null,
                    dazhongshow: null,
                    dzfl:null,
                    myfrom:null,
                    myto: null,
                    sizefrom: null,
                    sizeto:null,
                    useobj: '',
                    zhuangj: null,
                    activitytag:null,   
                    isaddcar: '0', 
                    delivery: '',                
                    // size: 20,
                    // current: 1
                },
                m_modal:null,
                classifydata:null,
                temp_pop:null,
                pub_pop:null,
                key_pop:null,
                savetemp_pop:null,
                sty_clsss:null,
                public_clsss:null,
                xuekedata:null,
                dazhongdata:null,
                pubObjCheck:null,//出版社选中数据
                startTime :{
                    disabledDate: time => {
                        if(vm.tempform.pubto){
                            return (
                                time.getTime() > new Date(vm.tempform.pubto).getTime()
                            );
                        }
                    }
                },
                endTime: {
                    disabledDate: time => {
                        if(vm.tempform.pubfrom){
                            return (
                                time.getTime() < new Date(vm.tempform.pubfrom).getTime()
                            );
                        }
                    }
                },
                // applyArr:[],
                bindArr:[],
                // sydxChecked:[]  //6.10改适用对象
            }
        },
        components: {
           Row, Col, Form, FormItem, Input, Button,Notification,  Checkbox, DatePicker,CheckboxGroup,Select,Option
        },
        mounted() {
            let vm = this;
            vm.bindArr = vm.zzArr;
            vm.$nextTick(() => {
                let isType = vm.isShowType;
                for(var key in isType){
                    vm[key] = isType[key];
                }
            })
        },
        /* watch:{
            sydxChecked(val) {
                let vm = this;
                vm.tempform.dzlx = val ? val.join(',') : null;
            } 
        }, //6.10改适用对象*/
        methods: {
            //弹开收起
            toggleSlide(s) {
                let vm = this,
                    div = document.getElementById('search_top_con');
                div.style.transition = 'height ' + s + 'ms';
                vm.dropdown = !vm.dropdown;
                if (vm.dropdown) vm.H = `280px`; else vm.H = `14px`
            },
            iSlogin(){
                return Cookies.get('token') ? true :false;
            },
            //检索
            onSubmit() {
                let vm = this,
                    queryFormData=JSON.parse(JSON.stringify(vm.tempform)),
                    isbns = queryFormData.isbns,
                    activitytag = queryFormData.activitytag;
                if(isbns && isbns != '') queryFormData.isbns = isbns.replace(/-/g,'');
                if(activitytag && activitytag.length >0) queryFormData.activitytag = activitytag.join(','); else queryFormData.activitytag = '';
                delete queryFormData.subjectShow;
                delete queryFormData.dazhongshow;
                let doId = +localStorage.getItem('doId') + 1;
                localStorage.setItem('doId', doId);
                insertPoint(queryFormData, 'click', 'search', doId); //添加“高级检索”埋点
                queryFormData.goodstype = vm.goodsType;
                vm.$emit('submitForm', queryFormData);
            },
            toggleAdditionalSearch() {
    this.showAdditionalSearch = !this.showAdditionalSearch;
  },
            //清除
            clearValue(prop,val,data) {
                let vm = this;
                vm.tempform[prop] = null;
                if(val) vm[val] = null;
                if(data) vm.tempform[data] = null;
            },
            //重置
            resetForm() {
                let vm = this;
                vm.classifydata = null;
                vm.xuekedata = null;
                vm.dazhongdata = null;
                vm.tempform.xkfl = null;
                vm.tempform.dzfl = null;
                vm.tempform.pubid = null;
                vm.goodsType = 1;
                vm.activitytag = null
                vm.tempform.isbns = null;
                vm.tempform.bookname = null;
                vm.tempform.myfrom = null;
                vm.tempform.myto = null;
                vm.tempform.author = null;
                vm.tempform.useobj='';
                vm.tempform.zhuangj = null;
                vm.tempform.delivery =null
                // vm.sydxChecked = []; //6.10改适用对象
                // vm.tempform.dzlx = null; //6.10改适用对象
                // vm.$refs.tempform.resetFields();
            },
            //中图法
            ztfflWindow() {
                let vm = this;
                vm.m_modal = popup('<classify-pop @close="close" @ok="submit" :msg="msg"/>', {
                    option: {
                        title: '中图法分类',
                        width: '800px'
                    },
                    popup: {
                        data(){
                            return {
                                msg: vm.classifydata
                            }
                        },
                        components: {
                            classifyPop
                        },
                        methods: {
                            submit(data){
                                let str = String(data.msgCode);
                                vm.$set(vm.tempform,'ztf',str);
                                vm.classifydata = data.dataStr;
                                vm.m_modal.hide();
                            },
                            close(data){
                                vm.m_modal.hide();
                            }
                        }
                    }
                });
                vm.m_modal.show();
            },
            //学科分类
            styClass() {
                let vm = this;
                vm.sty_clsss = popup('<studyclass @close="close" @ok="submit" :msg="msg"/>', {
                    option: {
                        title: '学科分类',
                        width: '630px'
                    },
                    popup: {
                        data(){
                            return {
                                msg: vm.xuekedata
                            }
                        },
                        components: {
                            studyclass
                        },
                        methods: {
                            submit(data){
                                vm.xuekedata = data;
                                let arr = data.split('|');
                                vm.tempform.subjectShow = arr[1];
                                vm.tempform.xkfl = arr[0];
                                vm.sty_clsss.hide();
                            },
                            close(data){
                                vm.sty_clsss.hide();
                            }
                        }
                    }
                });
                vm.sty_clsss.show();
            },
            //大众分类
            pubClass() {
                let vm = this;
                vm.public_clsss = popup('<publicpop @close="close" @ok="submit" :msg="msg" :search="0" :datatype="3"/>', {
                    option: {
                        title: '大众分类',
                        width: '600px',
                        height: '560px'
                    },
                    popup: {
                        data(){
                            return {
                                msg: vm.dazhongdata
                            }
                        },
                        components: {
                            publicpop//中图组件
                        },
                        methods: {
                            submit(data){
                                vm.dazhongdata = data;
                                let arr = data.split('|');
                                vm.tempform.dazhongshow = arr[1];
                                vm.tempform.dzfl = arr[0];
                                vm.public_clsss.hide();
                            },
                            close(data){
                                vm.public_clsss.hide();
                            }
                        }
                    }
                });
                vm.public_clsss.show();
            },
            //出版社
            pubpop() {
                let vm = this;
                vm.pub_pop = popup('<pub-dialog @close="close" :msg="msg" @ok="submit" />',{
                    option:{
                        title:'出版社选择',
                        width:'630px'
                    },
                    popup:{
                        data(){
                            return{
                                msg: vm.pubObjCheck
                            }
                        },
                        components:{
                            pubDialog
                        },
                        methods:{
                            submit(data){
                                vm.tempform.pubname = data.pubname;
                                vm.tempform.pubid = data.pubid;
                                vm.pubObjCheck =  data.choosedData;
                                vm.pub_pop.hide();
                            },
                            close(data){
                                vm.pub_pop.hide();
                            }
                        }
                    }
                })
                vm.pub_pop.show();
            },
            //关键词
            multiplePop(txt,flag) {
                let vm = this,
                    val = '';
                val = vm.tempform[flag];
                vm.key_pop = popup('<key-value-pop @close="close" @ok="submit" :msg="msg" />',{
                    option:{
                        title:`多个${txt}批量查询`,
                        width:'336px'
                    },
                    popup:{
                        data(){
                            return{
                                msg:{
                                    val:val,
                                    flag:flag
                                }
                            }
                        },
                        components:{
                            keyValuePop
                        },
                        methods:{
                            submit(data){
                                let flag = data.flag;
                                vm.tempform[flag] = data.val;
                                vm.key_pop.hide();
                            },
                            close(){
                                vm.key_pop.hide();
                            }
                        }
                    }
                })
                vm.key_pop.show();
            },
            
        }
    };
</script>

<style lang='scss' scoped>
    .search-box1 {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        padding: 0 15px 15px 15px;
        margin: 0 auto;
        /* border-top: 2px solid #333;
        border-bottom: 2px solid #333;
        background-color: yellowgreen; */

    }

    .suppldetaibox-top {
        width: 95%;
        margin: 25px auto;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .flex-container {
        display: flex;
        flex-wrap: wrap;
    }

    .flex-item {
        flex: 0 0 calc(8.14% - 10px);
        /* 每个元素占据约 7.14% 的宽度，减去间隔 */
        margin: 5px;
        /* 设置元素间隔 */
        text-align: center;
        /* 文字居中显示 */
        cursor: pointer;
        font-weight: 400;
        line-height: 30px;
        /* 鼠标指针样式为手型 */
    }

    .selected {
        background-color: lightblue;
        font-weight: 700;
        /* 设置选中样式，可以根据需要调整 */
    }

    .el-form-item__content {
        line-height: 30px !important;
        font-size: 14px;
    }

    .suppldetaibox {
        margin: 0 auto;
        width: 80%;
        /* height: 3000px; */
        background-color: #b82830;
        
    }

    .el-dropdown-link {
        cursor: pointer;
        color: #409EFF;
    }

    .el-icon-arrow-down {
        font-size: 12px;
    }

    .titleNames {}

    .mySelect {
        width: 100px;
    }

    .search-wrap {
        background-color: #fff;
        position: relative;
        overflow: hidden;

        .drop_btn {
            position: absolute;
            display: block;
            line-height: 30px;
            padding: 0px 40px;
            cursor: pointer;
            bottom: 0px;
            right: 0px;
            color: #999;
        }

        .no-margin {
            margin: 0 !important;
            // width:72px;
        }

        /* .el-input {
            width: 192px;
        } */

        .el-input__inner {
            /* padding: 0px 8px; */
            height: 35px;
            /* width: 192px; */
        }

        .s-input {
            float: left;
            width: 75px;

            .el-form-item__content {
                .midbox {
                    width: 52px;
                }
            }

            .el-input__inner {
                padding: 0px 8px;
                width: 52px;
            }
        }

        .date-input {
            float: left;
            width: 130px;

            .el-input__inner {
                padding: 0px 8px;
                width: 128px;
            }
        }

        .el-input--prefix .el-input__inner {
            padding-left: 25px;
        }

        .line {
            text-align: center;
        }

        .s-input {
            .el-input {
                width: 70%;
            }

            i {
                font-style: normal;
            }
        }

        .el-form-item__label {
            padding-right: 5px;
            font-size: 12px;
        }

        .search-btn {
            text-align: center;
            padding-top: 15px;
        }

        //表单清除
        .labelwrap {
            position: relative;

            .circleclose {
                display: none
            }

            .el-form-item__content:hover .circleclose {
                position: absolute;
                cursor: pointer;
                top: 3px;
                right: 0px;
                height: 24px;
                line-height: 24px;
                width: 24px;
                text-align: center;
                color: #bcc0c5;
                display: block;
            }
        }
    }

    /* 分类弹框样式 */
    .cont-sty {

        //学科、大众
        .el-col .treebox {
            width: 209px;
            height: 323px;
            padding: 15px 0 0 15px;
            padding-right: 0px;
            margin: 28px 0 0 38px;
            background-color: #fff;
            border-radius: 4px;
            border: solid 1px #c9d7e8;

            .search-sty {
                .el-input__inner {
                    width: 200px;
                    height: 32px;
                    padding-left: 28px;
                    background-color: #fff;
                    border-radius: 16px;
                    height: 28px;
                    line-height: 28px;
                    border: solid 1px #b6d2e6;
                }

                .el-icon-search {
                    line-height: 32px;
                }
            }

            .lefttree {
                height: 291px;
                overflow: auto;
                list-style: none;

                .check-box {
                    cursor: pointer;
                    margin-top: 10px;
                }
            }

            .tit {
                font-weight: bold;
                font-size: 13px;
            }

            .right-tree {
                width: 209px;
                height: 301px;
                overflow: auto;
                list-style: none;
                padding: 0px;

                >li {
                    cursor: pointer;
                    margin-top: 10px;

                    span {
                        display: inline-block;
                        width: 170px;
                        font-size: 12px;
                    }

                    i {
                        font-size: 17px;
                        color: #bbc8d4;
                    }

                    &:hover i {
                        color: #1c7bd3;
                    }
                }

                >li:hover {
                    color: #1c7bd3;
                }
            }

            .noData {
                text-align: center;
                font-size: 12px;

                img {
                    height: 90px;
                    width: 70px;
                    margin: 30px auto 15px;
                    display: block;
                }

                .p {
                    margin: 4px;
                }
            }

        }
    }

    .clearbtn {
        float: right;
        margin-right: 18px;
        width: 47px;
        height: 22px;
        line-height: 22px;
        background-color: #ffeaea;
        border-radius: 2px;
        border: 1px solid #f2c3c3;
        color: #ce4747;
    }

    .btnbase {
        border: 0px;
        // border-radius: 50px;
        font-weight: bold;
        font-size: 12px;
        cursor: pointer;
        // padding:0 24px;
        display: inline-block;
        height: 33px;
        line-height: 33px;
        margin: 8px 12px;
        width: 70px;
        background-color: #deefff;
        border-radius: 4px;
    }

    .btn_box {
        //按钮样式
        text-align: center;
        margin-top: 15px;

        .btn_sure {
            @extend .btnbase;
            color: #fff;
            background-color: #2c88f4;
        }

        .btn_canle {
            @extend .btnbase;
            color: #2c88f4;
            background-color: #deefff;
        }

        .btn_green {
            @extend .btnbase;
            color: #fff;
            background-color: #67c23a;
        }
    }



    .zjd {
        margin: 30px auto;
        height: 700px;
        position: relative;

        img {
            width: 100%;
            height: 100%;
        }
    }

    .zjdBg {
        /* 
    position: fixed;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    // background: rgba(235, 228, 228 / 80%);
    z-index: 100;
    overflow-y: hidden; */

        .zjdContent {
            height: 100%;
            color: #fff;

            .supplier {
                height: 40px;
                line-height: 40px;
                text-align: center;
                background-color: cadetblue;
            }

            .nextTime {
                height: 40px;
                line-height: 40px;
                text-align: center;
                background-color: #fb7d0f;
            }

            .activityContent {
                // display: flex;
                height: 100%;

                .Sessions {
                    width: 100%;
                    height: 100%;
                    line-height: 50px;
                    text-align: center;
                    // background-color: aquamarine;
                }
            }
        }
    }

    .zjdClose {
        position: absolute;
        width: 30px;
        height: 30px;
        top: 20px;
        right: 20px;
        cursor: pointer;
        z-index: 109;

        img {
            width: 30px;
            height: 30px;
        }
    }

    .zjdBox {
        width: 420px;
        height: 520px;
        position: absolute;
        left: 50%;
        transform: translate(-50%, 0);
    }

    .Sign {
        height: 300px;
        text-align: center;
        display: flex;
        padding: 0;
        flex-direction: column;
        justify-content: space-around;
        color: #000;

        .success {
            font-size: 22px;
        }

        .continuity {
            font-size: 25px;
        }

        .el-button {
            margin-bottom: 50px;
        }

        p {
            text-align: left;
            display: flex;
            justify-content: center;
        }
    }

    .zjdGet {
        position: fixed;
        top: 20px;
        left: 20px;
        background: rgba(0, 0, 0, 0.3);
        width: 90px;
        // height: 120px;
        text-align: center;
        cursor: pointer;
        z-index: 99;
    }

    .zjdimg img {
        width: 60px;
    }

    .zjdtext {
        color: #fff;
        font-size: 12px;
        line-height: 30px;

        >b {
            font-weight: normal;
        }
    }

    .TopComStyle {
        position: relative;
        height: 60px;
        width: 100%;
        background-color: rgba(255, 255, 255, 1);
        box-shadow: undefined, inset 0px -1px 0px 0px rgba(0, 0, 0, 0.08);

        .qiandao {
            position: fixed;
            display: flex;
            flex-direction: column;
            align-items: center;
            right: 200px;
            margin-top: 50px;
            cursor: pointer;

            // z-index: 2;
            .daka {
                font-size: 25px;
            }
        }

        .el-dropdown {
            cursor: pointer;
        }
    }

    .topContainer {
        width: 1200px;
        height: 100%;
        margin: 0px auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: white;
    }

    /* 1 */
    .topConLeft {
        display: flex;
        align-items: center;
        justify-content: space-around;
        font-size: 17px;
        cursor: pointer;
    }

    .topConLeft img {
        width: 150px;
        height: 55px;
    }

    .topConLeft span {
        cursor: pointer;
        color: #666;
        font-size: 16px;
        margin-left: 25px;
        padding: 0px 3px;
        line-height: 30px;
    }

    .topConLeft span.cur {
        // color: #fb7d0f;
        border-bottom: 3px solid #fb7d0f;
    }

    /* 2 */
    .el-input {
        /* width: 250px; */
        text-align: left;
        font-family: PingFangSC-Regular;
    }

    .topContainer>>>.el-input__inner {
        color: rgba(0, 0, 0, 0.25);
        font-size: 14px;
    }

    /* 3 */
    .TopConRight {
        color: black;
        color: rgba(102, 102, 102, 1);
        /* font-size: 14px; */
        font-size: 16px;

    }

    .TopConRight>span {
        margin-left: 15px;
    }

    .q {
        width: 100%;
        display: flex;
        justify-content: space-between;

        .r {
            margin: 0 auto;
        }

        .r div {
            width: 375px;
            height: 50px;
            line-height: 50px;
            text-align: center;
            background-color: yellowgreen;
            border: 1px solid #000;
            font-size: 20px;
        }

        // .zjdBox {
        //     width: 500px;

        //     background-color: #fff;
        // }

        .hdcc {
            width: 150px;
            height: 30px;
            background-color: #63000f;
            border-radius: 30px;
            line-height: 30px;
            text-align: center;
            margin: 0 auto;
        }

        .prInfo {
            position: absolute;
            top: 80px;
            right: 35px;
            width: 330px;
            height: 400px;
            background-color: #fff;
            border-radius: 10px;
        }

        .prInfo-info {
            width: 150px;
            height: 30px;
            background-color: #63000f;
            border-radius: 30px;
            margin: 10px auto;
            line-height: 30px;
            text-align: center;

        }

        .notice {
            width: 270px;
            height: 300px;
            border-radius: 8px;
            // border: 1px solid #eee;

        }

        .notice__inner {
            width: 100%;
            height: 100%;
            overflow: hidden;
            font-size: 14px;
            color: #999;
        }

        .notice__box {
            animation: roll 2s linear infinite;
        }

        .notice__item {
            width: 100%;
            height: 100px;
            line-height: 100px;
            padding: 0 12px;
            overflow: hidden;
            text-align: center;
            white-space: nowrap;
        }

        @keyframes roll {
            0% {
                transform: translatey(0);
            }

            100% {
                transform: translatey(-300px);
            }
        }

        .zjdtime {
            font-size: 24px;
            position: absolute;
            top: 0;
            left: 0;
        }

        .hdcc1 {
            width: 300px;
            height: 400px;
            background-color: pink;
            position: absolute;
            top: 80px;
            left: 35px;
        }

        .hdcc1 div {
            width: 342px;
            height: 40px;
            border: 1px solid #fff;
            line-height: 40px;
            text-align: center;
        }


        /* .popbox {
            height: 42px;
            width: 42px;
            position: absolute;
            bottom: 30px;
            left: 50%;
            z-index: 999;
            margin-left: -21px;
            cursor: pointer;
        } */

        /* .lottery-alertgx {
            -moz-border-radius: 15px;
            border-radius: 15px;
        } */

        /* .lottery-alertgx,
        .lottery-tip {
            max-width: 100%;
            text-align: center;
            z-index: 10000;

            -webkit-transform: translateY(-50%);
            -moz-transform: translateY(-50%);
            -ms-transform: translateY(-50%);
            -o-transform: translateY(-50%);
            transform: translateY(-50%)
        } */

        .lottery-alerth1 {
            font-size: 20px;
            font-weight: 400;
            color: #000;
            position: relative;
            // margin-top: 20px;
        }

        .zjdContainer {
            font-family: Avenir, Helvetica, Arial, sans-serif;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
            text-align: center;
            color: #666;
            background-color: #bd2a33;
            height: 100%;
            width: 100%;
        }

        .zjdtitle {
            position: absolute;
            top: 20px;
            width: 100%;
            text-align: center;
        }

        .myprize {
            -moz-border-radius: 20px;
            border-radius: 20px;
            padding: 8px 20px;
            color: #edd251;
            font-weight: bold;
            font-size: 18px;

            margin: auto;
            // background: #fff;
        }

        .myprizeimg {
            width: 260px;
            height: 260px;
            background-color: pink;
            display: flex;
            justify-content: center;
            align-items: center;
            position: absolute;
            left: 120px;
            bottom: 90px;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .myprizetitle {
            position: absolute;
            bottom: 45px;
            left: -5%;
            width: 150px;
            height: 30px;
            border-radius: 30px;
            border: 1px solid #999;
            text-align: center;
            line-height: 30px;
            margin-left: 200px;
        }

        .linqu {
            position: absolute;
            bottom: 0;
            left: 37%;
            width: 100px;
            height: 30px;
            border-radius: 30px;
            border: 1px solid #999;
            text-align: center;
            line-height: 30px;
            margin-bottom: 1px;
            cursor: pointer;
        }

        .nostate {
            width: 500px;
            height: 100px;
            // border: 1px solid #fff;
            line-height: 100px;
            text-align: center;
            font-size: 38px;
            position: absolute;
            left: 30%;
            top: 36%;
        }

    }


    ul {
        list-style: none;
    }

    a img {
        border: none;
    }

    a {
        color: #333;
        text-decoration: none;
    }

    a:hover {
        color: #ff0000;
    }

    #mooc {
        width: 399px;
        border: 5px solid #ababab;
        border-radius: 15px;
        box-shadow: 2px 2px 10px #ababab;
        margin: 50px auto 0;
        text-align: left;
        height: 300px;
        /* 增加整体高度 */
    }

    #moocTitle {
        height: 62px;
        overflow: hidden;
        font-size: 26px;
        line-height: 62px;
        padding-left: 30px;
        background-image: linear-gradient(top, #f05e6f, #c9394a);
        border: 1px solid #f05e6f;
        border-radius: 8px 8px 0 0;
        color: #fff;
        position: relative;
    }

    #moocTitle a {
        position: absolute;
        right: 10px;
        bottom: 10px;
        display: inline;
        color: #fff;
        font-size: 12px;
        line-height: 24px;
    }

    #moocBox {
        height: 335px;
        /* 增加内容区域高度 */
        margin-top: 15px;
        overflow: hidden;
        height: 335px;
        margin-left: 10px;
        margin-right: 10px;

    }

    #mooc ul li {
        height: 40px;
        /* 增加单行高度 */
        line-height: 40px;
        /* 设置行高 */
    }

    #mooc ul li a {
        width: 180px;
        float: left;
        display: block;
        overflow: hidden;
        text-indent: 15px;
        height: 40px;
    }

    #mooc ul li span {
        float: right;
        color: #999;
    }
    .bottxtx{
        font-size: 16px;
        display: block !important;
        /* margin-left: 4%; */
        text-align: center;
        color: #63000f;
        font-weight: 700;
    }
</style>


// WEBPACK FOOTER //
// src/components/SearchComponent.vue